import React from 'react';
import ReactDOM from 'react-dom';
import Services from './Services';

function App() {
  return <Services />;
}

// Mount the App component if the target element exists
const mountNode = document.getElementById('react-root');
if (mountNode) {
  ReactDOM.render(<App />, mountNode);
}

export default App;
